import React, { Fragment } from "react";
import { Alert, AlertTitle, Grid, Typography } from "@mui/material";
import { getErrorContent } from "utils/errorHelpers";

interface ErrorAlertProps {
  error: unknown;
}

export function ErrorAlert({ error }: ErrorAlertProps) {
  const errorContent = getErrorContent(error);

  return (
    <Grid size={12}>
      <Alert severity="error">
        <AlertTitle>{errorContent.title}</AlertTitle>
        {typeof errorContent.content === "string" ? (
          <Typography variant="subtitle1" gutterBottom component="div">
            {errorContent.content}
          </Typography>
        ) : (
          Object.keys(errorContent.content).map((errKey, i) => (
            <Fragment key={`error-${i}`}>
              {errKey && (
                <Typography variant="subtitle1" gutterBottom component="div">
                  {errKey}:
                </Typography>
              )}
              {typeof errorContent.content === "object" &&
                errorContent.content[errKey]?.map((err, j) => (
                  <Typography key={`error-${i}-${j}`} variant="body2">
                    {err}
                  </Typography>
                ))}
            </Fragment>
          ))
        )}
      </Alert>
    </Grid>
  );
}
